$(document).on('turbolinks:load ready', function() {
  handle_media_access_type_toggle();
  $(document).on('change', '#product_media_attributes_access_type', function () {
    handle_media_access_type_toggle();
  });

  $(document).on('change', '#product_media_attributes_bundled', function () {
    toggle_media_file_2_field();
  });

  initMediaLayoutSorting();
  initVideoThumbnails();
});

function handle_media_access_type_toggle() {
  const accessType = $('#product_media_attributes_access_type').val();

  const renewalSection = $('#renewal-section');
  const salePriceSection = $('#sale-price-section');
  const bundledSection = $('#bundled-toggle-section');

  if (accessType === 'premium') {
    renewalSection.show().find('input').attr('required', true);
    bundledSection.show();
    salePriceSection.show();
  } else {
    renewalSection.hide().find('input').val('0.00').removeAttr('required');
    salePriceSection.hide().find('input').val('');
    bundledSection.hide().find('input[type=checkbox]').prop('checked', false);
  }
  toggle_media_file_2_field();
}

function toggle_media_file_2_field() {
  const isBundled = $('#product_media_attributes_bundled').is(':checked');
  const file2Section = $('#file-2-section');
  const removeField = $('#remove_file_2_field');
  const inputs = file2Section.find('input');

  if (isBundled) {
    file2Section.show();
    if (removeField.length) {
        removeField.val('false');
        inputs.removeAttr('required');
    } else {
        inputs.attr('required', true);
    }
  } else {
    file2Section.hide();
    inputs.val('').removeAttr('required');
    removeField.length ? removeField.val('true') : file2Section.find('.custom-file-label').text('');
  }
}

function initMediaLayoutSorting() {
  $(document).on('change', '.sort-mode-checkbox', function () {
    if ($(this).is(':checked')) {
      $('.sort-mode-checkbox').not(this).prop('checked', false);
    }
  });
}

function initVideoThumbnails() {
  const $modal = $('#videoModal');
  const $iframe1 = $('#video-slide-1 iframe');
  const $iframe2 = $('#video-slide-2 iframe');
  const $controls = $modal.find('.video-controls-wrapper');
  const $heading = $modal.find('.modal-heading');
  const $carousel = $('#videoCarousel');
  const $allItems = $carousel.find('.carousel-item');

  const getVimeoUrl = id => `https://player.vimeo.com/video/${id}?title=0&byline=0&portrait=0&badge=0&autopause=0`;
  
  function stopAllVideos() {
    $carousel.find('iframe').each(function () {
      $(this).attr('src', $(this).attr('src'));
    });
  }

  // Thumbnail click: open modal and load video(s)
  $(document).on('click', '.play-video', function () {
    const vimeoId = $(this).data('vimeoId');
    const vimeo2Id = $(this).data('vimeo-2-id');

    $iframe1.attr('src', getVimeoUrl(vimeoId));

    if (vimeo2Id) {
      $iframe2.attr('src', getVimeoUrl(vimeo2Id));
      $('#video-slide-2').removeClass('d-none');
      $controls.removeClass('d-none');
      $heading.removeClass('d-none').html('Video <span>1</span> of <span>2</span>');
    } else {
      $iframe2.attr('src', '');
      $('#video-slide-2').addClass('d-none');
      $controls.addClass('d-none');
      $heading.addClass('d-none');
    }

    $allItems.removeClass('active');
    $('#video-slide-1').addClass('active');
  });

  // Handle prev/next buttons
  $(document).on('click', '#videoModal a[data-slide], #videoModal a[data-bs-slide]', function () {
    stopAllVideos();
    
    setTimeout(() => {
      const $activeIndex = $carousel.find('.carousel-item.active').index();
      const totalSlides = $carousel.find('.carousel-item:not(.d-none)').length;

      if (!$heading.hasClass('d-none')) {
        $heading.html(`Video <span>${$activeIndex + 1}</span> of <span>${totalSlides}</span>`);
      }
    }, 650);
  });

  // Modal close: stop videos
  $(document).on('click', '.close-modal', function () {
    $iframe1.add($iframe2).attr('src', '');
  });
}
